import type { ReactNode } from "react";

type AdminSectionCardProps = {
  eyebrow: string;
  title: string;
  description: string;
  children: ReactNode;
};

const AdminSectionCard = ({ eyebrow, title, description, children }: AdminSectionCardProps) => {
  return (
    <section className="rounded-[1.75rem] border border-myteengig-border bg-white p-6 shadow-sm">
      <p className="text-xs font-semibold uppercase tracking-[0.18em] text-myteengig-primary">{eyebrow}</p>
      <h1 className="mt-2 text-2xl font-bold text-myteengig-text-primary">{title}</h1>
      <p className="mt-2 max-w-3xl text-sm text-myteengig-text-muted">{description}</p>
      <div className="mt-6">{children}</div>
    </section>
  );
};

export default AdminSectionCard;
